import { Injectable } from '@angular/core';
import csvDownload from 'json-to-csv-export';

@Injectable({providedIn: 'root'})
export class CSVService {
    constructor() { }
    
    public download(headers: string[], data: any[], filename: string): void {
        csvDownload({
            data,
            filename,
            delimiter: ',',
            headers
        });
    }

    public async readCSV(file: File)
    {
        const response = await this.readFile(file);
        let arrObjetos = this.cargarData(response);
        const cantidad = 5000;
        let cargas = Math.floor((arrObjetos.length / cantidad) + 1);

        let lstArrCargas = [];
        for(let i= 0 ; i < cargas; i++) {
            lstArrCargas[i] = [];
            let limite = arrObjetos.length > cantidad ? cantidad : arrObjetos.length;
            for(let j = 0 ; j<limite ; j++) {
                lstArrCargas[i].push(arrObjetos.shift());
            }
        }
        return lstArrCargas;
    }

    private readFile(fileToRead: File): any {
        return new Promise((resolve, reject) => {
            let content = '';
            const fileReader = new FileReader();
        
            fileReader.onloadend = function(e: any) {
                content = e.target.result;
                const result = content.split(/\r\n|\n/);
                resolve(result);
            };
        
            fileReader.onerror = function(e: any) {
                reject(e);
            };
            fileReader.readAsText(fileToRead);
        });
    }

    private cargarData(arrDatos: any)
    {
        if (arrDatos && arrDatos.length <= 1) return null;
        let headers = arrDatos[0].split(',');

        let arrObjetos = [];
        for(let i =1; i < arrDatos.length; i++){
            let lineaActual = arrDatos[i].split(',');
            let objActual = {};
            let j = 0;
            headers.forEach(element => {
                objActual[element] = lineaActual[j];
                j++;
            });
            arrObjetos.push(objActual);
        }
        return arrObjetos;
    }
    
}
